// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fZ9R","fullView":"styles_fullView__10sl4"};